/* eslint-disable */
export function getAllShapesMock() {
  return [
    {
      'ShapeId': 1,
      'Name': 'Square',
      'Products': [],
      'LayoutTemplates': []
    },
    {
      'ShapeId': 2,
      'Name': 'Rectangle',
      'Products': [
        {
          'ProductId': 6,
          'Title': '6333610',
          'Created': '05/05/2017 13:27:39',
          'LastModified': '06/04/2020 10:09:00',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 4,
          'ShapeId': 2,
          'Width': 1128,
          'Height': 739,
          'DefaultLayoutId': 6,
          'BackgroundClassName': 'cake-party-cake',
          'BackgroundWidth': 1380,
          'BackgroundHeight': 1002,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 690,
          'OptimalHeight': 500,
          'MinimalWidth': 345,
          'MinimalHeight': 250,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-6.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-6.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': true,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 51,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-party-cake'
        },
        {
          'ProductId': 7,
          'Title': '6333602',
          'Created': '05/16/2017 13:31:20',
          'LastModified': '08/19/2019 13:13:37',
          'LastModifiedBy': 'ad-acc\\asja.de.kruif',
          'Active': 1,
          'ProductTypeId': 5,
          'ShapeId': 2,
          'Width': 1636,
          'Height': 1099,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-maxi-party-cake',
          'BackgroundWidth': 2000,
          'BackgroundHeight': 1440,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-7.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-7.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-maxi-party-cake'
        },
        {
          'ProductId': 9,
          'Title': '6311019',
          'Created': '05/16/2017 14:17:12',
          'LastModified': '05/15/2020 15:30:34',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 7,
          'ShapeId': 2,
          'Width': 245,
          'Height': 206,
          'DefaultLayoutId': 6,
          'BackgroundClassName': 'cake-mini-tompouce',
          'BackgroundWidth': 275,
          'BackgroundHeight': 236,
          'Bleed': 0,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': 726,
          'MultiCloneWidth': 1124,
          'IsMultiClone': true,
          'OptimalWidth': 137,
          'OptimalHeight': 118,
          'MinimalWidth': 69,
          'MinimalHeight': 59,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-9.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-9.png',
          'OverlayImagePath': 'products/overlays/product-9.png',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 30,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-mini-tompouce'
        },
        {
          'ProductId': 10,
          'Title': '6311018',
          'Created': '05/16/2017 14:18:24',
          'LastModified': '03/24/2020 11:36:36',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 8,
          'ShapeId': 2,
          'Width': 525,
          'Height': 206,
          'DefaultLayoutId': 6,
          'BackgroundClassName': 'cake-tompouce',
          'BackgroundWidth': 566,
          'BackgroundHeight': 254,
          'Bleed': 0,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': 726,
          'MultiCloneWidth': 1122,
          'IsMultiClone': true,
          'OptimalWidth': 283,
          'OptimalHeight': 127,
          'MinimalWidth': 142,
          'MinimalHeight': 64,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': true,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-10.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-10.png',
          'OverlayImagePath': 'products/overlays/product-10.png',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-tompouce'
        },
        {
          'ProductId': 11,
          'Title': '6380005',
          'Created': '05/16/2017 14:20:22',
          'LastModified': '03/07/2018 09:31:22',
          'LastModifiedBy': 'EDITOR02\\editoruser',
          'Active': 1,
          'ProductTypeId': 9,
          'ShapeId': 2,
          'Width': 957,
          'Height': 662,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-choco-ipad',
          'BackgroundWidth': 1106,
          'BackgroundHeight': 814,
          'Bleed': 14,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 1,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-11.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-11.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-choco-ipad'
        },
        {
          'ProductId': 12,
          'Title': '6380004',
          'Created': '05/16/2017 14:21:37',
          'LastModified': '03/07/2018 09:33:54',
          'LastModifiedBy': 'EDITOR02\\editoruser',
          'Active': 1,
          'ProductTypeId': 10,
          'ShapeId': 2,
          'Width': 308,
          'Height': 544,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-choco-iphone',
          'BackgroundWidth': 332,
          'BackgroundHeight': 686,
          'Bleed': 10,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': true,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-12.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-12.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-choco-iphone'
        },
        {
          'ProductId': 13,
          'Title': '6380003',
          'Created': '05/16/2017 14:22:41',
          'LastModified': '03/07/2018 09:36:35',
          'LastModifiedBy': 'EDITOR02\\editoruser',
          'Active': 1,
          'ProductTypeId': 13,
          'ShapeId': 2,
          'Width': 957,
          'Height': 662,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-choco-fotolist',
          'BackgroundWidth': 1098,
          'BackgroundHeight': 808,
          'Bleed': 14,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 1,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-13.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-13.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-choco-fotolist'
        },
        {
          'ProductId': 14,
          'Title': '6333601',
          'Created': '05/16/2017 14:23:57',
          'LastModified': '08/19/2019 13:13:50',
          'LastModifiedBy': 'ad-acc\\asja.de.kruif',
          'Active': 1,
          'ProductTypeId': 11,
          'ShapeId': 2,
          'Width': 993,
          'Height': 762,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-choco-heart',
          'BackgroundWidth': 1108,
          'BackgroundHeight': 822,
          'Bleed': 14,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 1,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': true,
          'CakeMaskPathDefinition': 'M 992.6,182 992.6,180.4 992.5,179 992.2,175 991.3,169.1 991.1,167.6 990.5,164.4 989.9,160.9 988,153.5 988,153.5    986.8,148.8 986.6,148.1 986,146.1 983.3,139 980.6,131.6 980.3,131 979.9,129.7 977.2,123.8 974.5,118 974.1,117.3 973.7,116.4    972.4,114 971.4,112.1 970.6,110.9 969.8,109.4 965.6,101.9 961.3,94.9 957.5,89.4 953.6,84 951.3,81.2 948.6,77.7 943.9,72.3    939.3,67.2 935.8,64.1 929.2,57.8 921.9,51.2 916.5,47.3 913,44.5 912.7,44.3 911.5,43.4 906.1,39.4 900.3,35.9 900.3,35.9    899.1,35.2 898.7,34.9 894.9,32.4 889.1,29.3 880.6,24.6 871.7,20.3 867.3,18.6 866.7,18.4 858.5,14.8 850,12.1 847.2,11.2    844.2,10.2 841.9,9.5 841.5,9.4 840.7,9.2 834.6,7.4 825.3,5.5 823.4,5.1 823.4,5.1 823.4,5.1 815.7,3.5 808.8,2.7 804.4,2    799.4,1.5 796.3,1.2 786.3,0.4 785.1,0.4 775.5,0 766.2,0 761.6,0.2 756.5,0.4 756.1,0.4 748,0.8 739.1,1.6 730.3,2.7 721.8,4.3    720.5,4.6 717.9,5.1 708.6,7.4 704.6,8.6 703.2,9 702.1,9.3 699.4,10.2 689.7,13.3 688.3,13.8 683.9,15.2 676.6,18.3 671.5,20.3    669.3,21.3 665,23 662.6,24.2 653.8,28.5 644.9,33.2 636.4,38.3 632.9,40.6 632.9,40.6 628.3,43.7 619.4,50 610.5,56.2 602.4,63.3    602.3,63.4 598.1,66.8 589.1,75.6 586.5,78.1 578.8,85.9 571.8,94.1 564.9,102.3 558.3,110.9 552.1,119.9 550.9,122 549,124.6    539.4,141 530.9,158.2 524.3,173 522.5,177.6 521.2,180.4 519.7,184.4 518.1,188.3 512.3,203.5 506.5,218.7 505.3,222.5    503.8,226.5 496.5,250 489.2,226.5 487.7,222.4 486.5,218.7 480.7,203.5 474.9,188.3 473.3,184.4 471.8,180.4 470.5,177.6    468.7,173 462.1,158.2 453.6,141 444,124.6 442.1,122 440.9,119.9 434.7,110.9 428.1,102.3 421.2,94.1 414.2,85.9 408.4,80.1    408.4,80.1 408.4,80.1 406.5,78.1 403.9,75.6 394.9,66.8 390.7,63.4 390.6,63.3 382.5,56.2 373.6,50 364.7,43.7 360.1,40.6    360.1,40.6 356.6,38.3 348.1,33.2 339.2,28.5 330.4,24.2 330.4,24.2 328,23 323.7,21.3 321.5,20.3 316.4,18.3 309.1,15.2    304.7,13.8 303.3,13.3 293.6,10.2 290.9,9.4 289.8,9 288.4,8.6 284.4,7.4 275.1,5.1 272.5,4.6 271.2,4.3 262.7,2.7 253.9,1.6    245,0.8 236.9,0.4 236.5,0.4 231.4,0.2 226.8,0 217.5,0 207.9,0.4 206.7,0.4 196.7,1.2 193.6,1.5 188.6,2 184.2,2.7 177.3,3.5    167.7,5.5 158.4,7.4 152.3,9.2 151.5,9.4 151.1,9.5 148.8,10.2 145.8,11.2 143,12.1 134.5,14.8 126.3,18.4 125.7,18.6 121.3,20.3    112.4,24.6 103.9,29.3 98.1,32.4 94.3,34.9 93.9,35.2 92.7,35.9 92.7,35.9 86.9,39.4 81.5,43.4 80.3,44.3 80,44.5 76.5,47.3    71.1,51.2 63.8,57.8 57.2,64.1 53.7,67.2 49.1,72.3 44.4,77.7 41.7,81.2 39.4,84 35.5,89.4 31.7,94.9 27.4,101.9 23.2,109.4    22.4,110.9 21.6,112.1 20.6,114 19.3,116.4 18.9,117.3 18.5,118 15.8,123.8 13.1,129.7 12.7,131 12.4,131.6 9.7,139 7,146.1    6.4,148.1 6.2,148.8 5,153.5 5,153.5 3.1,160.9 2.5,164.4 1.9,167.6 1.7,169.1 0.8,175 0.5,179 0.4,180.4 0.4,182 0,189.4 0,193.3    0,196.8 0,200 0.4,207 0.8,217.2 1.1,220.2 1.2,221.1 1.9,229.7 3.1,238.2 4.6,246.4 7,256.2 9.3,266 11.2,272.6 11.6,274.2    12,275.4 12,275.4 15.1,285.1 17.6,291.5 17.8,292.1 20.9,301.1 24,308.2 24.3,308.9 24.3,308.9 24.3,308.9 27.4,315.2 28.6,317.2    30.1,320.7 35.2,329.6 39.4,337.1 42.2,341.9 47.9,351.9 56,365.6 64.5,379.2 73,392.5 81.9,405.4 86.7,412 92,419.5 100.2,430.3    105.1,437 111.6,445 112.1,445.6 112.7,446.4 117.5,452.3 130.2,467.5 134.6,472.5 144.5,483.9 155.7,496.4 167.3,508.5 181.6,523    195.9,537.4 195.9,537.4 197.8,539.4 212.1,553 226.4,566.3 241.1,579.6 255.8,592.9 270.5,605.8 285.5,618.3 300.6,630.8    316.1,643.3 323.8,649.3 328.4,653 347,667.5 362.8,679.2 368.2,683.1 372.5,686.2 373.9,687.2 379,690.9 395.3,701.9 396.3,702.5    398.7,704.2 411.1,712.4 415.7,715.1 416.9,715.9 426.9,721.9 437,728 450.1,735.8 456.4,739.5 462.1,742.9 470.6,747.9    479.1,752.6 480.2,753.2 482.6,754.6 491.7,759.4 496.5,762 501.3,759.4 510.4,754.6 512.8,753.2 513.9,752.6 522.4,747.9    530.9,742.9 536.6,739.5 542.9,735.8 556,728 566.1,721.9 576.1,715.9 577.3,715.1 581.9,712.4 594.3,704.2 596.7,702.5    597.7,701.9 614,690.9 619.1,687.2 620.5,686.2 624.8,683.1 630.2,679.2 646,667.5 664.6,653 669.2,649.3 676.9,643.3 692.4,630.8    707.5,618.3 722.5,605.8 737.2,592.9 751.9,579.6 766.6,566.3 780.9,553 795.2,539.4 797.1,537.4 797.1,537.4 811.4,523    825.7,508.5 837.3,496.4 848.5,483.9 858.4,472.5 862.8,467.5 875.5,452.3 880.3,446.4 880.9,445.6 881.4,445 887.9,437    892.8,430.3 901,419.5 906.3,412 911.1,405.4 920,392.5 928.5,379.2 937,365.6 945.1,351.9 950.8,341.9 953.6,337.1 957.8,329.6    962.9,320.7 964.4,317.2 965.6,315.2 968.7,308.9 968.7,308.9 968.7,308.9 969,308.2 972.1,301.1 975.2,292.1 975.4,291.5    977.9,285.1 981,275.4 981,275.4 981.4,274.2 981.8,272.6 983.7,266 986,256.2 988.4,246.4 989.9,238.2 991.1,229.7 991.8,221.1    991.9,220.2 992.2,217.2 992.6,207 993,200 993,196.8 993,193.3 993,189.4  Z',
          'BleedMaskPathDefinition': 'M 494.2,733.6 491.8,732.2 490.5,731.5 482.6,727.1 468.4,718.7 462.3,715.1 449.4,707.5 439.2,701.2 429.6,695.5   428.3,694.7 423.9,692.1 412.2,684.3 409.6,682.5 408.5,681.8 392.8,671.2 387.7,667.6 386.4,666.7 382.3,663.6 377,659.8   361.5,648.4 343.3,634.2 338.6,630.4 331,624.5 315.8,612.2 286,587.5 271.8,575 242.6,548.6 228.6,535.6 214.7,522.3 184.5,491.8   173.3,480.1 162.5,468 152.6,456.5 148.4,451.9 136,437 131.2,431.1 130.7,430.5 130.4,430.1 124.1,422.4 119.3,415.9 111.4,405.4   106.3,398 101.5,391.5 93,379.2 84.8,366.4 76.5,353.1 68.7,339.9 63,329.9 60.2,325 56,317.8 51.5,309.8 50,306.4 48.7,304.1   45.7,298 43.2,292.4 40.4,284 40,283.1 37.7,277.2 34.8,267.8 34.6,267.4 34.3,266.3 32.5,259.9 28.1,241.5 26.8,234.4 25.8,227   25.1,219.4 25.1,218.3 24.7,215.3 24.4,205.9 24,199.3 24,190.1 24.4,182.6 24.4,181.8 24.5,181.1 24.7,177.6 25.5,172.5   25.7,171.2 26.2,168.6 26.6,165.9 28.4,159 28.4,158.9 29.2,155.7 29.4,155.1 29.8,153.4 32.1,147.5 34.6,140.6 34.9,140   35.3,138.9 40.1,128.6 40.4,128 40.7,127.3 41.8,125.2 42.6,123.8 43.2,122.7 44.1,121.1 48.1,114.1 51.8,108.1 58.4,98.6   60.4,96.3 63.1,92.9 67.1,88.1 70.6,84.3 73.4,81.7 80.1,75.4 86.2,69.8 90.9,66.4 94.1,63.9 94.4,63.8 95.9,62.6 100.2,59.5   105.7,56.2 106.6,55.5 106.8,55.4 110.4,53.1 115.5,50.3 123.5,45.9 130.8,42.4 135,40.8 136.1,40.3 142.9,37.3 153.5,33.9 156,33   158,32.5 158.2,32.4 158.8,32.3 164.2,30.7 172.5,29 181.2,27.2 187.7,26.4 191.5,25.8 196,25.4 199,25.1 207.6,24.4 208.4,24.4   218,24 226.3,24 230.4,24.2 235,24.4 235.4,24.4 243.4,24.7 251.2,25.4 259,26.4 266.4,27.8 267.5,28.1 269.9,28.5 278,30.6   281.8,31.7 282.9,32 283.8,32.3 286.6,33.1 295.4,35.9 296.8,36.5 300.7,37.7 307.3,40.5 312.2,42.5 314.4,43.4 318.1,44.9   319.7,45.7 328.4,49.9 336.4,54.1 343.8,58.5 351.1,63.5 367.7,75.2 374.7,81.2 375,81.5 378.8,84.6 387.3,92.9 389.6,95.2   396.5,102.2 409.4,117.4 415.2,125 420.8,133 422.1,135.1 423.7,137.5 432.5,152.4 440.4,168.4 446.6,182.4 448.4,186.9   449.6,189.5 451,193.2 452.5,197 463.8,226.7 465,230.3 466.4,234.3 496.5,330.2 526.6,234.3 528,230.3 529.2,226.7 540.5,197   542,193.2 543.4,189.5 544.6,186.9 546.4,182.4 552.6,168.4 560.5,152.4 569.3,137.5 570.9,135.1 572.2,133 577.8,125 583.6,117.4   596.5,102.1 603.4,95.2 605.9,92.8 614.2,84.6 618,81.5 618.3,81.2 625.3,75.2 641.9,63.5 649.2,58.5 656.6,54.1 664.6,49.9   673.3,45.7 674.9,44.9 678.6,43.4 680.8,42.5 685.7,40.5 692.3,37.8 696.2,36.5 697.6,35.9 706.4,33.1 709.2,32.3 710.1,32   711.2,31.7 715,30.6 723.1,28.5 725.5,28.1 726.6,27.8 734,26.4 741.8,25.4 749.6,24.7 757.6,24.4 758,24.4 762.5,24.2 766.7,24   775,24 784.6,24.4 785.4,24.4 794,25.1 797,25.4 801.5,25.8 805.3,26.4 811.8,27.2 820.5,29 828.8,30.7 834.4,32.3 834.8,32.4   835,32.5 837,33 839.5,33.9 850.1,37.3 856.9,40.3 858,40.8 862.2,42.4 869.5,45.9 877.7,50.4 882.6,53.1 886.2,55.4 886.4,55.5   887.3,56.2 892.8,59.5 897.1,62.6 898.7,63.8 898.9,63.9 902,66.4 906.8,69.9 912.9,75.4 919.6,81.7 922.4,84.3 925.9,88.1   929.9,92.9 932.6,96.3 934.6,98.6 941.2,108.1 944.9,114.1 948.9,121.1 949.8,122.7 950.4,123.8 951.4,125.6 952.3,127.3 952.6,128   952.9,128.6 957.7,138.9 958.1,140 958.4,140.6 960.9,147.7 963.2,153.4 963.6,155.1 963.8,155.7 964.8,159.5 966.4,165.9   966.8,168.6 967.3,171.2 967.5,172.5 968.3,177.6 968.5,181.1 968.6,181.8 968.6,182.6 969,190.1 969,199.3 968.6,205.9   968.3,215.3 967.9,218.3 967.9,219.4 967.2,227 966.2,234.4 964.9,241.5 960.5,259.9 958.7,266.3 958.4,267.4 958.1,268.1   955.3,277.2 953,283.1 952.5,284.3 949.8,292.4 947.3,298 944.3,304.1 943,306.4 941.5,309.8 937,317.8 932.8,325 929.9,330.1   924.3,339.9 916.5,353.1 908.2,366.4 900,379.2 891.5,391.5 886.7,398 881.6,405.4 873.5,416.2 868.9,422.4 862.6,430.1   862.3,430.5 861.7,431.2 857,437 844.6,451.9 840.3,456.7 830.5,468 819.7,480.1 808.5,491.8 778.3,522.3 764.4,535.6 750.4,548.6   721.3,575 707,587.5 677.2,612.2 662,624.5 654.2,630.6 649.7,634.2 631.5,648.4 616,659.8 610.6,663.8 606.6,666.7 605.3,667.6   600.2,671.2 584.5,681.8 583.4,682.5 580.8,684.3 569.1,692.1 564.7,694.7 563.4,695.5 553.5,701.4 543.6,707.5 530.7,715.1   524.3,718.9 510.4,727.1 502.5,731.5 501.2,732.2 498.8,733.6 496.5,734.8 Z',
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-14.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-14.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': true,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-choco-heart'
        },
        {
          'ProductId': 15,
          'Title': '6380002',
          'Created': '05/16/2017 14:25:19',
          'LastModified': '07/17/2019 10:29:39',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 12,
          'ShapeId': 2,
          'Width': 331,
          'Height': 331,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-choco-lolly',
          'BackgroundWidth': 396,
          'BackgroundHeight': 396,
          'Bleed': 12,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': 1034,
          'MultiCloneWidth': 739,
          'IsMultiClone': true,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': '{\'Cloning\':{\'Items\':[{\'Left\':0,\'Top\':142,\'Rotation\':-75},{\'Left\':408,\'Top\':0,\'Rotation\':105},{\'Left\':0,\'Top\':703,\'Rotation\':-75},{\'Left\':408,\'Top\':561,\'Rotation\':105}]},\'Masking\':{\'PredefinedShape\':1},\'IsLollyCake\':true}',
          'ImagePath': 'products/product-15.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-15.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': true,
          'CornerRadius': 165,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-choco-lolly'
        },
        {
          'ProductId': 19,
          'Title': '6333625',
          'Created': '06/16/2017 12:38:18',
          'LastModified': '09/23/2020 14:28:21',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 17,
          'ShapeId': 2,
          'Width': 1063,
          'Height': 1063,
          'DefaultLayoutId': 6,
          'BackgroundClassName': '3d-cake',
          'BackgroundWidth': 1063,
          'BackgroundHeight': 1063,
          'Bleed': 8,
          'DefaultFontId': 13,
          'SideBleedTop': 43,
          'SideBleedRight': 49,
          'SideBleedBottom': 67,
          'SideBleedLeft': 49,
          'SideWidth': 1063,
          'SideHeight': 325,
          'IsMultiDimension': true,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-19.jpg',
          'BackgroundImagePath': 'products/backgrounds/product-19.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': '3d-cake'
        },
        {
          'ProductId': 20,
          'Title': '6311027',
          'Created': '07/21/2017 14:15:20',
          'LastModified': '10/25/2017 10:59:50',
          'LastModifiedBy': 'HEMALOCAL\\molenkampm',
          'Active': 1,
          'ProductTypeId': 7,
          'ShapeId': 2,
          'Width': 245,
          'Height': 206,
          'DefaultLayoutId': 6,
          'BackgroundClassName': 'cake-mini-tompouce',
          'BackgroundWidth': 275,
          'BackgroundHeight': 236,
          'Bleed': 0,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': 726,
          'MultiCloneWidth': 1124,
          'IsMultiClone': true,
          'OptimalWidth': 137,
          'OptimalHeight': 118,
          'MinimalWidth': 69,
          'MinimalHeight': 59,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': true,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-20.PNG',
          'BackgroundImagePath': 'products/backgrounds/product-20.png',
          'OverlayImagePath': 'products/overlays/product-20.png',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-mini-tompouce'
        },
        {
          'ProductId': 21,
          'Title': '6333600',
          'Created': '07/21/2017 14:18:53',
          'LastModified': '03/25/2022 16:28:33',
          'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
          'Active': 1,
          'ProductTypeId': 4,
          'ShapeId': 2,
          'Width': 1128,
          'Height': 739,
          'DefaultLayoutId': 19,
          'BackgroundClassName': 'cake-party-cake',
          'BackgroundWidth': 1380,
          'BackgroundHeight': 1002,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 30,
          'OptimalHeight': 30,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-21.png',
          'BackgroundImagePath': 'products/backgrounds/product-21.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': 'products/logo_overlays/product-21-20220325162832933.png',
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': true,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-party-cake'
        },
        {
          'ProductId': 22,
          'Title': '6333604',
          'Created': '07/21/2017 14:20:54',
          'LastModified': '03/07/2018 09:19:50',
          'LastModifiedBy': 'EDITOR02\\editoruser',
          'Active': 1,
          'ProductTypeId': 4,
          'ShapeId': 2,
          'Width': 1128,
          'Height': 739,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-party-cake',
          'BackgroundWidth': 1380,
          'BackgroundHeight': 1002,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-22.png',
          'BackgroundImagePath': 'products/backgrounds/product-22.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-party-cake'
        },
        {
          'ProductId': 23,
          'Title': '6333614',
          'Created': '07/21/2017 14:22:13',
          'LastModified': '03/07/2018 09:22:03',
          'LastModifiedBy': 'EDITOR02\\editoruser',
          'Active': 1,
          'ProductTypeId': 4,
          'ShapeId': 2,
          'Width': 1128,
          'Height': 739,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-party-cake',
          'BackgroundWidth': 1380,
          'BackgroundHeight': 1002,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-23.png',
          'BackgroundImagePath': 'products/backgrounds/product-23.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-party-cake'
        },
        {
          'ProductId': 24,
          'Title': '6333605',
          'Created': '07/21/2017 14:24:13',
          'LastModified': '04/04/2022 16:22:21',
          'LastModifiedBy': 'ad-acc\\anouk.hollebeek',
          'Active': 1,
          'ProductTypeId': 5,
          'ShapeId': 2,
          'Width': 1636,
          'Height': 1099,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-maxi-party-cake',
          'BackgroundWidth': 2000,
          'BackgroundHeight': 1440,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-24.png',
          'BackgroundImagePath': 'products/backgrounds/product-24.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-maxi-party-cake'
        },
        {
          'ProductId': 25,
          'Title': '6333615',
          'Created': '07/21/2017 14:26:09',
          'LastModified': '08/06/2020 11:53:15',
          'LastModifiedBy': 'ad-acc\\emmhijdra',
          'Active': 1,
          'ProductTypeId': 5,
          'ShapeId': 2,
          'Width': 1636,
          'Height': 1099,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-maxi-party-cake',
          'BackgroundWidth': 2000,
          'BackgroundHeight': 1440,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-25.png',
          'BackgroundImagePath': 'products/backgrounds/product-25.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': true,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-maxi-party-cake'
        },
        {
          'ProductId': 26,
          'Title': '6333626',
          'Created': '07/21/2017 14:29:47',
          'LastModified': '03/07/2018 14:20:51',
          'LastModifiedBy': 'EDITOR02\\editoruser',
          'Active': 1,
          'ProductTypeId': 17,
          'ShapeId': 2,
          'Width': 1063,
          'Height': 1063,
          'DefaultLayoutId': 11,
          'BackgroundClassName': '3d-cake',
          'BackgroundWidth': 1063,
          'BackgroundHeight': 1063,
          'Bleed': 8,
          'DefaultFontId': 13,
          'SideBleedTop': 43,
          'SideBleedRight': 49,
          'SideBleedBottom': 67,
          'SideBleedLeft': 49,
          'SideWidth': 1063,
          'SideHeight': 325,
          'IsMultiDimension': true,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-26.png',
          'BackgroundImagePath': 'products/backgrounds/product-26.png',
          'OverlayImagePath': '',
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': '3d-cake'
        },
        {
          'ProductId': 33,
          'Title': '17326401',
          'Created': '11/20/2018 14:30:15',
          'LastModified': '09/05/2019 16:27:55',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 23,
          'ShapeId': 2,
          'Width': 921,
          'Height': 1276,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'wine-label-red',
          'BackgroundWidth': 1038,
          'BackgroundHeight': 4144,
          'Bleed': 0,
          'DefaultFontId': 13,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 921,
          'OptimalHeight': 1276,
          'MinimalWidth': 307,
          'MinimalHeight': 425,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-33.png',
          'BackgroundImagePath': 'products/backgrounds/product-33.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': null,
          'WatermarkOffsetTop': null,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'wine-label-red'
        },
        {
          'ProductId': 34,
          'Title': '17327401',
          'Created': '11/20/2018 14:32:31',
          'LastModified': '04/02/2019 11:44:50',
          'LastModifiedBy': 'ad-acc\\asja.de.kruif',
          'Active': 1,
          'ProductTypeId': 24,
          'ShapeId': 2,
          'Width': 921,
          'Height': 1276,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'wine-label-white',
          'BackgroundWidth': 1038,
          'BackgroundHeight': 4144,
          'Bleed': 0,
          'DefaultFontId': 13,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 921,
          'OptimalHeight': 1276,
          'MinimalWidth': 307,
          'MinimalHeight': 425,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-34.png',
          'BackgroundImagePath': 'products/backgrounds/product-34.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': null,
          'WatermarkOffsetTop': null,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'wine-label-white'
        },
        {
          'ProductId': 35,
          'Title': '17329401',
          'Created': '11/20/2018 14:34:24',
          'LastModified': '01/04/2023 10:01:23',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 22,
          'ShapeId': 2,
          'Width': 921,
          'Height': 1276,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'wine-label-champagne',
          'BackgroundWidth': 1120,
          'BackgroundHeight': 4206,
          'Bleed': 0,
          'DefaultFontId': 13,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 921,
          'OptimalHeight': 1276,
          'MinimalWidth': 307,
          'MinimalHeight': 425,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-35.png',
          'BackgroundImagePath': 'products/backgrounds/product-35.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': null,
          'WatermarkOffsetTop': null,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 0,
          'LayoutTemplates': [],
          'Backgroundclassname': 'wine-label-champagne'
        },
        {
          'ProductId': 37,
          'Title': '6333635',
          'Created': '06/07/2019 14:20:51',
          'LastModified': '08/28/2023 11:48:00',
          'LastModifiedBy': 'ad-acc\\jules.pasteuning',
          'Active': 1,
          'ProductTypeId': 6,
          'ShapeId': 2,
          'Width': 1033,
          'Height': 1010,
          'DefaultLayoutId': 6,
          'BackgroundClassName': 'cake-heart-cake',
          'BackgroundWidth': 1080,
          'BackgroundHeight': 1060,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 540,
          'OptimalHeight': 530,
          'MinimalWidth': 270,
          'MinimalHeight': 265,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': true,
          'CakeMaskPathDefinition': 'M2.9,307.7L2.9,307.7c0.1,0,0.2,0.1,0.2,0.2c44.3,298.1,230.8,559,498.6,697.6l0.2,0.1c9.1,4.7,20,4.8,29.1,0.2  c0-0.1,0-0.2,0.1-0.2C798.9,867,985.3,606.2,1029.8,308c0,0,0-0.1,0.1-0.1l0.2-0.2c15-100.9-29.6-203.3-113.7-260.9  c-84-57.6-195.6-62.4-284.1-12.2c0,0,0,0,0,0.1c0,0.1,0,0.1-0.1,0.2c-35.1,19.9-75,30.5-115.4,30.5l0,0  c-40.4,0-80.3-10.6-115.4-30.5h-0.1l0,0c-88.7-50.3-200.2-45.6-284.5,12S-12.1,206.7,2.9,307.7z',
          'BleedMaskPathDefinition': 'M516.5,946.6C272.2,815.2,102.6,574.6,61.6,300c-0.2-1.6-0.5-3.3-0.9-4.9c-10-77.5,24.8-155.5,89.4-199.6  c34.9-23.8,76-36.4,118.8-36.4c36.4,0,72.1,9.3,103.3,27l13.5,7.7h1c40.4,20,85,30.5,130,30.5c50.5,0,100.5-13.2,144.5-38.2l7-4  l0.1-0.1C697.8,67,730.8,59,764.4,59c42.9,0,83.9,12.6,118.7,36.4c64.3,44.1,99.1,121.7,89.3,199c-0.4,1.8-0.8,3.7-1,5.6  C930.1,574.6,760.6,815.3,516.5,946.6z',
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-8.png',
          'BackgroundImagePath': 'products/backgrounds/product-8.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': null,
          'WatermarkOffsetTop': null,
          'DisplayWatermark': false,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': 50,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-heart-cake'
        },
        {
          'ProductId': 38,
          'Title': '6330054',
          'Created': '12/14/2020 13:54:23',
          'LastModified': '12/17/2020 16:40:57',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 25,
          'ShapeId': 2,
          'Width': 319,
          'Height': 319,
          'DefaultLayoutId': 6,
          'BackgroundClassName': 'cake-cupcake',
          'BackgroundWidth': 452,
          'BackgroundHeight': 430,
          'Bleed': 24,
          'DefaultFontId': 13,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': 1053,
          'MultiCloneWidth': 1396,
          'IsMultiClone': true,
          'OptimalWidth': 319,
          'OptimalHeight': 319,
          'MinimalWidth': 69,
          'MinimalHeight': 69,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': '{\'Cloning\':{\'Items\':[{\'Left\':24,\'Top\':24},{\'Left\':24,\'Top\':367},{\'Left\':24,\'Top\':710},{\'Left\':367,\'Top\':24},{\'Left\':367,\'Top\':367},{\'Left\':367,\'Top\':710}]}}',
          'ImagePath': 'products/product-38.png',
          'BackgroundImagePath': 'products/backgrounds/product-38.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': false,
          'WatermarkImagePath': null,
          'WatermarkOffsetLeft': null,
          'WatermarkOffsetTop': null,
          'DisplayWatermark': false,
          'RoundedCorners': true,
          'CornerRadius': 160,
          'FontSizeOverride': null,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-cupcake'
        },
        {
          'ProductId': 39,
          'Title': '10270050',
          'Created': '08/23/2021 16:39:13',
          'LastModified': '01/18/2022 11:12:41',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 4,
          'ShapeId': 2,
          'Width': 1128,
          'Height': 739,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-party-cake',
          'BackgroundWidth': 1380,
          'BackgroundHeight': 1002,
          'Bleed': 0,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 690,
          'OptimalHeight': 500,
          'MinimalWidth': 345,
          'MinimalHeight': 250,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-39.png',
          'BackgroundImagePath': 'products/backgrounds/product-39.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': true,
          'WatermarkImagePath': 'products/logo_overlays/product-39-20210906150925362.png',
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': true,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': null,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-party-cake'
        },
        {
          'ProductId': 40,
          'Title': '10270051',
          'Created': '09/01/2021 11:50:32',
          'LastModified': '09/06/2021 15:09:02',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 4,
          'ShapeId': 2,
          'Width': 1128,
          'Height': 739,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'hema-giftcard',
          'BackgroundWidth': 1128,
          'BackgroundHeight': 739,
          'Bleed': 0,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': null,
          'OptimalHeight': null,
          'MinimalWidth': null,
          'MinimalHeight': null,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': false,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-40.png',
          'BackgroundImagePath': 'products/backgrounds/product-40.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': true,
          'WatermarkImagePath': 'products/logo_overlays/product-40-20210906150902464.png',
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': true,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': null,
          'LayoutTemplates': [],
          'Backgroundclassname': 'hema-giftcard'
        },
        {
          'ProductId': 41,
          'Title': '6330067',
          'Created': '07/21/2022 10:20:15',
          'LastModified': '07/21/2022 10:20:15',
          'LastModifiedBy': 'ad-acc\\emsgak',
          'Active': 1,
          'ProductTypeId': 4,
          'ShapeId': 2,
          'Width': 1128,
          'Height': 739,
          'DefaultLayoutId': 11,
          'BackgroundClassName': 'cake-party-cake',
          'BackgroundWidth': 1380,
          'BackgroundHeight': 1002,
          'Bleed': 49,
          'DefaultFontId': 24,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 690,
          'OptimalHeight': 500,
          'MinimalWidth': 345,
          'MinimalHeight': 250,
          'SectionPadding': 10,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': false,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-41.png',
          'BackgroundImagePath': 'products/backgrounds/product-41.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': false,
          'EnableEnhancement': true,
          'WatermarkImagePath': 'products/logo_overlays/product-41-20220721102016324.png',
          'WatermarkOffsetLeft': 0,
          'WatermarkOffsetTop': 0,
          'DisplayWatermark': true,
          'RoundedCorners': false,
          'CornerRadius': 0,
          'FontSizeOverride': null,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-party-cake'
        },
        {
          'ProductId': 43,
          'Title': '6355261',
          'Created': '10/11/2022 14:10:59',
          'LastModified': '02/20/2023 08:58:11',
          'LastModifiedBy': 'ad-acc\\jules.pasteuning',
          'Active': 1,
          'ProductTypeId': 26,
          'ShapeId': 2,
          'Width': 992,
          'Height': 992,
          'DefaultLayoutId': 6,
          'BackgroundClassName': 'cake-rond-cake',
          'BackgroundWidth': 1152,
          'BackgroundHeight': 1152,
          'Bleed': 40,
          'DefaultFontId': 13,
          'SideBleedTop': null,
          'SideBleedRight': null,
          'SideBleedBottom': null,
          'SideBleedLeft': null,
          'SideWidth': null,
          'SideHeight': null,
          'IsMultiDimension': false,
          'MultiCloneHeight': null,
          'MultiCloneWidth': null,
          'IsMultiClone': false,
          'OptimalWidth': 992,
          'OptimalHeight': 992,
          'MinimalWidth': 300,
          'MinimalHeight': 300,
          'SectionPadding': 0,
          'Rotation': 0,
          'HasOutline': true,
          'GenerateBiggerPreviewImage': false,
          'IsMaskedCake': false,
          'CakeMaskPathDefinition': null,
          'BleedMaskPathDefinition': null,
          'IsPreviewImageOnTop': true,
          'ImageGenerationData': null,
          'ImagePath': 'products/product-43.png',
          'BackgroundImagePath': 'products/backgrounds/product-43.png',
          'OverlayImagePath': null,
          'ShowClipPathWarning': true,
          'EnableEnhancement': false,
          'WatermarkImagePath': 'products/logo_overlays/product-43-20221118171623349.png',
          'WatermarkOffsetLeft': -75,
          'WatermarkOffsetTop': -100,
          'DisplayWatermark': false,
          'RoundedCorners': true,
          'CornerRadius': 496,
          'FontSizeOverride': null,
          'LayoutTemplates': [],
          'Backgroundclassname': 'cake-rond-cake'
        }
      ],
      'LayoutTemplates': []
    },
    {
      'ShapeId': 3,
      'Name': 'TestShape',
      'Products': [],
      'LayoutTemplates': []
    }
  ];
}